var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroductionRoundLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#a6917d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "103,143 -12,271 271,251"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "231,168 75,-16 271,2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#241306",
    fillOpacity: 0.501961,
    points: "60,268 245,129 271,253"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "271,125 119,170 210,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9f1da",
    fillOpacity: 0.501961,
    points: "105,-16 -11,62 -10,227"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a95917",
    fillOpacity: 0.501961,
    points: "83,50 174,111 -11,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffdcc5",
    fillOpacity: 0.501961,
    points: "121,197 173,162 204,200"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "121,-16 271,23 161,122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2f1300",
    fillOpacity: 0.501961,
    points: "113,108 76,34 78,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "115,117 156,163 105,142"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1eee0",
    fillOpacity: 0.501961,
    points: "66,134 -16,131 72,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#feffff",
    fillOpacity: 0.501961,
    points: "139,72 271,153 247,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d48032",
    fillOpacity: 0.501961,
    points: "67,113 123,178 -16,157"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#88450e",
    fillOpacity: 0.501961,
    points: "173,145 131,46 126,122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6b4221",
    fillOpacity: 0.501961,
    points: "225,133 263,251 170,161"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#040504",
    fillOpacity: 0.501961,
    points: "92,193 169,204 91,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffa838",
    fillOpacity: 0.501961,
    points: "67,227 91,232 89,192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eeffff",
    fillOpacity: 0.501961,
    points: "1,145 -16,235 12,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ba5c06",
    fillOpacity: 0.501961,
    points: "10,247 50,228 12,153"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#260300",
    fillOpacity: 0.501961,
    points: "102,24 71,72 80,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0b08f",
    fillOpacity: 0.501961,
    points: "124,128 132,62 90,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d1816",
    fillOpacity: 0.501961,
    points: "17,268 77,168 79,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#622e00",
    fillOpacity: 0.501961,
    points: "115,29 144,66 90,26"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cce6f9",
    fillOpacity: 0.501961,
    points: "137,180 167,199 121,199"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f9fd",
    fillOpacity: 0.501961,
    points: "114,133 189,154 129,166"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e09f70",
    fillOpacity: 0.501961,
    points: "169,186 179,105 145,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2c2af",
    fillOpacity: 0.501961,
    points: "29,162 64,188 40,199"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c1b092",
    fillOpacity: 0.501961,
    points: "-16,81 174,-16 21,4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "177,-16 187,133 271,112"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#383421",
    fillOpacity: 0.501961,
    points: "92,177 155,180 163,161"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1b2c34",
    fillOpacity: 0.501961,
    points: "203,197 -2,257 216,261"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9f3900",
    fillOpacity: 0.501961,
    points: "21,153 65,186 35,142"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bb8561",
    fillOpacity: 0.501961,
    points: "167,188 172,207 242,184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2b46e",
    fillOpacity: 0.501961,
    points: "102,173 78,179 103,137"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1f1306",
    fillOpacity: 0.501961,
    points: "97,105 85,85 123,89"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#040a09",
    fillOpacity: 0.501961,
    points: "67,172 95,185 63,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6f4119",
    fillOpacity: 0.501961,
    points: "93,109 111,131 46,148"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#edf1ea",
    fillOpacity: 0.501961,
    points: "32,130 69,110 67,71"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#461e00",
    fillOpacity: 0.501961,
    points: "143,100 128,119 134,59"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cbcfc6",
    fillOpacity: 0.501961,
    points: "237,100 246,-16 221,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2d1604",
    fillOpacity: 0.501961,
    points: "125,161 121,266 88,211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2954a",
    fillOpacity: 0.501961,
    points: "92,227 62,228 88,203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "190,167 232,-16 178,-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#161213",
    fillOpacity: 0.501961,
    points: "39,219 37,202 61,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#96adb2",
    fillOpacity: 0.501961,
    points: "185,-16 177,53 170,6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#92551a",
    fillOpacity: 0.501961,
    points: "72,64 101,143 71,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ebb790",
    fillOpacity: 0.501961,
    points: "162,163 205,145 167,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#965720",
    fillOpacity: 0.501961,
    points: "144,62 129,42 107,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcffff",
    fillOpacity: 0.501961,
    points: "256,168 234,43 271,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e2e4dc",
    fillOpacity: 0.501961,
    points: "4,246 -16,154 13,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#341400",
    fillOpacity: 0.501961,
    points: "157,263 271,271 249,216"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecc5ac",
    fillOpacity: 0.501961,
    points: "61,138 17,142 57,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8faff",
    fillOpacity: 0.501961,
    points: "98,138 146,158 162,141"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e4aa8f",
    fillOpacity: 0.501961,
    points: "103,90 131,79 90,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#edcab6",
    fillOpacity: 0.501961,
    points: "263,182 246,189 230,186"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#713a13",
    fillOpacity: 0.501961,
    points: "249,262 202,191 267,186"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5faf3",
    fillOpacity: 0.501961,
    points: "221,160 211,159 229,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bb6920",
    fillOpacity: 0.501961,
    points: "9,200 53,232 11,234"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7934e",
    fillOpacity: 0.501961,
    points: "79,196 100,192 66,211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd2ab",
    fillOpacity: 0.501961,
    points: "88,56 100,36 114,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8f531f",
    fillOpacity: 0.501961,
    points: "167,103 146,140 120,119"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#414240",
    fillOpacity: 0.501961,
    points: "151,271 165,189 209,210"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4d1400",
    fillOpacity: 0.501961,
    points: "125,163 122,150 94,139"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5faf8",
    fillOpacity: 0.501961,
    points: "139,4 178,89 153,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#936549",
    fillOpacity: 0.501961,
    points: "75,216 62,194 39,187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#584e3a",
    fillOpacity: 0.501961,
    points: "267,135 208,148 232,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d5d0c1",
    fillOpacity: 0.501961,
    points: "-16,100 -16,174 95,16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1e7e2",
    fillOpacity: 0.501961,
    points: "213,143 243,58 245,126"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfc4ad",
    fillOpacity: 0.501961,
    points: "136,24 66,25 138,-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e39667",
    fillOpacity: 0.501961,
    points: "112,107 135,140 100,119"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1f4e3",
    fillOpacity: 0.501961,
    points: "244,161 244,146 241,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#080500",
    fillOpacity: 0.501961,
    points: "105,100 87,64 86,91"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c3e8fd",
    fillOpacity: 0.501961,
    points: "70,149 61,146 76,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d1d11",
    fillOpacity: 0.501961,
    points: "172,163 185,172 187,157"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b97f56",
    fillOpacity: 0.501961,
    points: "-4,151 18,138 48,206"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d3a289",
    fillOpacity: 0.501961,
    points: "201,194 183,171 131,183"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3c2608",
    fillOpacity: 0.501961,
    points: "97,24 81,35 119,36"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e78f32",
    fillOpacity: 0.501961,
    points: "99,174 97,140 39,160"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#53351f",
    fillOpacity: 0.501961,
    points: "218,185 271,179 230,148"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#604f3b",
    fillOpacity: 0.501961,
    points: "102,191 105,161 158,175"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8b5838",
    fillOpacity: 0.501961,
    points: "116,70 88,62 99,54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#988a6f",
    fillOpacity: 0.501961,
    points: "114,205 110,215 116,228"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e0d8bf",
    fillOpacity: 0.501961,
    points: "235,136 236,149 222,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2c2f27",
    fillOpacity: 0.501961,
    points: "208,141 208,164 217,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "245,-16 179,37 179,-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b1734c",
    fillOpacity: 0.501961,
    points: "190,167 189,203 165,196"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0c1a0",
    fillOpacity: 0.501961,
    points: "160,140 158,130 127,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c39569",
    fillOpacity: 0.501961,
    points: "157,116 137,91 152,85"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9e2f5",
    fillOpacity: 0.501961,
    points: "130,184 152,180 144,196"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcd6c1",
    fillOpacity: 0.501961,
    points: "124,88 111,88 132,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2c2a1e",
    fillOpacity: 0.501961,
    points: "193,155 193,170 212,156"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#749fb7",
    fillOpacity: 0.501961,
    points: "250,22 260,26 250,-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b97f43",
    fillOpacity: 0.501961,
    points: "82,117 91,110 73,86"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffe6",
    fillOpacity: 0.501961,
    points: "234,162 231,164 237,167"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#968a6b",
    fillOpacity: 0.501961,
    points: "223,149 197,158 187,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eff1eb",
    fillOpacity: 0.501961,
    points: "140,68 172,102 173,-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f3ab74",
    fillOpacity: 0.501961,
    points: "92,35 85,51 104,36"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2b3233",
    fillOpacity: 0.501961,
    points: "124,198 169,271 170,199"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cbc9be",
    fillOpacity: 0.501961,
    points: "105,159 99,144 102,175"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#05151e",
    fillOpacity: 0.501961,
    points: "209,271 148,271 215,223"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionRoundLow);
export default __webpack_public_path__ + "static/media/introduction_round_low.345202723fb1df495284c86a4d597fc6.svg";
export { ForwardRef as ReactComponent };